import { render, staticRenderFns } from "./GameTrackingPage.vue?vue&type=template&id=6c2983e8&scoped=true"
import script from "./GameTrackingPage.vue?vue&type=script&lang=js"
export * from "./GameTrackingPage.vue?vue&type=script&lang=js"
import style0 from "./GameTrackingPage.vue?vue&type=style&index=0&id=6c2983e8&prod&scoped=true&lang=css"
import style1 from "./GameTrackingPage.vue?vue&type=style&index=1&id=6c2983e8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2983e8",
  null
  
)

export default component.exports